import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "font-weight-bold mb-2" };
const _hoisted_2 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.tr('viiu.componentMuting.SELECTED_ALARM')), 1),
        _createElementVNode("div", { innerHTML: _ctx.description }, null, 8, _hoisted_2)
    ]));
}
